<script setup lang="ts">
import { BasicMenu } from '@/components/Menu'
import { RoutesDataItem } from '@/utils/routes'
import { toRefs } from 'vue'

interface Props {
  menuData: RoutesDataItem[]
  routeItem: RoutesDataItem
}

const props = withDefaults(defineProps<Props>(), {})
const { menuData, routeItem } = toRefs(props)
</script>

<template>
  <basic-menu :menu-data="menuData" :route-item="routeItem" />
</template>

<style scoped lang="less"></style>
